import { TypeOf } from '@guiker/yup-util'

import { lessee } from './lessee'

export const signatureAndLesseeInformation = lessee

export type SignatureAndLesseeInformation = TypeOf<typeof signatureAndLesseeInformation>
